export default "<!-- ko foreach: $data -->\n  <!-- ko component: { name: component, params: data } -->\n  <!-- /ko -->\n<!-- /ko --> ";